// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyASXtbnfBgif5YySrx5AOzmGAq4htZ4LZY",
  authDomain: "arconest-6472e.firebaseapp.com",
  projectId: "arconest-6472e",
  storageBucket: "arconest-6472e.firebasestorage.app",
  messagingSenderId: "985827685666",
  appId: "1:985827685666:web:67e40fb013b704250fa17b",
  measurementId: "G-MWB151MEMK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export {auth,app};

